"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/events/KeyCode
 */

/**
 * @enum {number}
 * @const
 */
var _default = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7ZUFJZTtFQUNiQSxJQUFJLEVBQUUsRUFETztFQUViQyxFQUFFLEVBQUUsRUFGUztFQUdiQyxLQUFLLEVBQUUsRUFITTtFQUliQyxJQUFJLEVBQUU7QUFKTyxDIiwibmFtZXMiOlsiTEVGVCIsIlVQIiwiUklHSFQiLCJET1dOIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ldmVudHMvS2V5Q29kZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==